import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { SuccessAction } from '../models/appointment-state.model';

interface IdSuccessAction {
    id: number,
    successAction: SuccessAction
}

interface AppointmentState {
    successAction?: IdSuccessAction | undefined
}

const initialState: AppointmentState = {};

export const appointmentSlice = createSlice({
    initialState,
    name: 'appointments',
    reducers: {
        setSuccessAction(state, action: PayloadAction<IdSuccessAction>) {
            state.successAction = {
                id: action.payload.id,
                successAction: action.payload.successAction,
            };
        },
        dismissSuccessAction(state) {
            state.successAction = undefined;
        },
    },
});

export const { setSuccessAction, dismissSuccessAction } = appointmentSlice.actions;
